import { dayKey, formatTime, numericDate } from 'utils/auditLabels';

const ONE_HOUR_MS = 60 * 60 * 1000;

/** 3e: older than an hour or overtaken by a realignment → stale; unreadable dates read fresh, and format as « — ». */
export const isStale = (analyzedAt: string, lastRunAt: string | null | undefined, now: number): boolean => {
  const analyzed = new Date(analyzedAt).getTime();
  const lastRun = lastRunAt ? new Date(lastRunAt).getTime() : Number.NaN;
  return now > analyzed + ONE_HOUR_MS || lastRun > analyzed;
};

const readable = (iso: string | null | undefined): iso is string => Boolean(iso) && !Number.isNaN(Date.parse(iso as string));
export const timeOf = (iso: string | null | undefined): string => (readable(iso) ? formatTime(iso) : '—');
export const dayOf = (iso: string | null | undefined): string => (readable(iso) ? numericDate(dayKey(iso)) : '—');
